<template>
  <v-toolbar flat class="zero_padding_toolbar">
    <v-avatar v-if="icon">
      <v-icon>{{ icon }}</v-icon>
    </v-avatar>
    <h2>{{ title }}</h2>
  
    <slot name="buttons"></slot>
  </v-toolbar>
</template>

<script>
export default {
  props: { title: String, icon: String },
};
</script>

<style>
.zero_padding_toolbar .v-toolbar__content {
  padding: 0x !important;
}
</style>